import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Formik, FormikValues } from 'formik';
import { RootState } from 'store';
import * as yup from 'yup';

import Field from 'components/Field';
import RegistrationOnboardingLayout from 'components/RegistrationOnboardingLayout';
import TextArea from 'components/TextArea';
import useIsDesktop from 'hooks/useIsDesktop';
import useStoreTranslation from 'hooks/useStoreTranslation';
import ResponseScreen, { BackgroundTypes, IconTypes } from 'screens/components/ResponseScreen';
import { sendEmail } from 'services/customerSupportService';
import { htmlT } from 'utils/generic';

import { Container, Header, StyledForm, ButtonContainer, SendButton } from './styles';

interface Values {
  message: string;
}

const Mail = () => {
  const history = useHistory();
  const { t } = useStoreTranslation();
  const isDesktop = useIsDesktop();
  const { accountResult } = useSelector((state: RootState) => state.user);
  const [loading, setLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);

  if (isDesktop) return null;

  const initialValues: Values = {
    message: '',
  };

  const validationSchema = yup.object().shape({
    message: yup.string().required(),
  });

  const handleSubmit = async (values: Values) => {
    setLoading(true);
    await sendEmail({ description: values.message });
    setSuccess(true);
    setLoading(false);
  };

  const handleGoHome = () => {
    if (accountResult?.type === 'admin') history.push('/corporate/dashboard');
    else history.push('/corporate/booking');
  };

  return (
    <RegistrationOnboardingLayout appBarTitle={t('customerSupport.title')} current={''}>
      <Container>
        <Header>{htmlT(t, 'customerSupport.mail.title')}</Header>

        <Formik
          onSubmit={handleSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
          isInitialValid={(formik: any) => validationSchema.isValidSync(formik.initialValues)}
        >
          {({ isValid }: FormikValues) => (
            <StyledForm>
              <Field name="message" label={t('customerSupport.mail.messageLabel')}>
                <TextArea placeholder={t('customerSupport.mail.messagePlaceholder')} />
              </Field>

              <ButtonContainer>
                <SendButton disabled={!isValid || loading} loading={loading}>
                  {t('customerSupport.mail.send')}
                </SendButton>
              </ButtonContainer>
            </StyledForm>
          )}
        </Formik>
      </Container>

      <ResponseScreen
        show={success}
        text={t('customerSupport.mail.success.title')}
        subText={t('customerSupport.mail.success.message', { mail: accountResult?.email })}
        buttonText={t('customerSupport.mail.success.continue')}
        buttonOnClick={handleGoHome}
        background={BackgroundTypes.Cloud}
        icon={IconTypes.PaperAirplane}
      />
    </RegistrationOnboardingLayout>
  );
};

export default Mail;
